module.exports={select:"Zaznacz",selected:"Zaznaczone"};